import { render, staticRenderFns } from "./DetailsImageUpload.vue?vue&type=template&id=0d794c0f"
import script from "./DetailsImageUpload.vue?vue&type=script&lang=ts"
export * from "./DetailsImageUpload.vue?vue&type=script&lang=ts"
import style0 from "./DetailsImageUpload.vue?vue&type=style&index=0&id=0d794c0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports